import React from 'react';
import { copyToClipboard } from './utils';
import styles from './ContactPopup.module.css';
import ContactForm from './ContactForm';
import SuccessMessage from './SuccessMessage';
import ContactInfoDisplay from './ContactInfo';

/**
 * Renders the appropriate content for the ContactPopup based on its state
 * @param {Object} params - Parameters
 * @param {boolean} params.hasTalentData - Whether talent data is available
 * @param {boolean} params.success - Whether email was sent successfully
 * @param {boolean} params.showContactInfo - Whether to show contact info
 * @param {Object} params.talent - Talent data
 * @param {string} params.option - Selected contact option
 * @param {string} params.message - Email message
 * @param {boolean} params.sending - Whether email is being sent
 * @param {string} params.error - Error message
 * @param {Function} params.t - Translation function
 * @param {Function} params.handleOptionChange - Function to handle option change
 * @param {Function} params.handleMessageChange - Function to handle message change
 * @param {Function} params.handleSubmit - Function to handle form submission
 * @param {Function} params.handlePopupClose - Function to handle popup close
 * @returns {React.ReactNode} - Content to render
 */
const renderContent = ({
  hasTalentData,
  success,
  showContactInfo,
  talent,
  option,
  message,
  sending,
  error,
  t,
  handleOptionChange,
  handleMessageChange,
  handleSubmit,
  handlePopupClose
}) => {
  if (!hasTalentData && !success) {
    return (
      <div className={styles.noDataMessage}>
        <p>{t('general.UI.no_data')}</p>
      </div>
    );
  }
  
  if (success) {
    return <SuccessMessage onClose={handlePopupClose} />;
  }
  
  if (showContactInfo) {
    return <ContactInfoDisplay 
      talent={talent} 
      onCopy={(text) => copyToClipboard(text, t)} 
      onClose={handlePopupClose} 
    />;
  }
  
  return (
    <ContactForm
      option={option}
      message={message}
      sending={sending}
      error={error}
      onOptionChange={handleOptionChange}
      onMessageChange={handleMessageChange}
      onSubmit={handleSubmit}
      onCancel={handlePopupClose}
    />
  );
};

export default renderContent; 